// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../styles/variables.css\"","primary":"_1_k_gZo5-7Mpg-hgqyLSzU","primaryLight":"#ABEAFF","default":"#868686","textDefault":"#808080","secondary":"_1ZUCGb7ff8izcIuy1DOiGc","secondaryLight":"#7FE7AB","button":"i-9OOYoI2STpPxzON3v16","link":"_2aqCjnBpbHgYkUFXndlqPO","plain":"_2FY3BWpMztyRi26A7xi_vs"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Button/Button.mod.css
// module id = 1058
// module chunks = 0